import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import StatusBadge, { StageBadge } from "@/components/StatusBadge";
import { GitBranch } from "lucide-react";

export default function ShipmentChain({ shipmentId }) {
  const [family, setFamily] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    let active = true;
    api.get(`/shipments/${shipmentId}/family`)
      .then((r) => { if (active) setFamily(Array.isArray(r.data) ? r.data : []); })
      .catch(() => { if (active) setFamily([]); });
    return () => { active = false; };
  }, [shipmentId]);

  if (family.length <= 1) return null;

  return (
    <div className="bg-white rounded-xl border border-border p-5" data-testid="shipment-chain">
      <h3 className="font-heading font-bold text-[#111411] mb-1 flex items-center gap-2">
        <GitBranch className="h-4 w-4 text-[#0B3D3D]" /> Shipment Chain
      </h3>
      <p className="text-xs text-muted-foreground mb-4">
        {family.length} shipments sent for this order — the newest is at the bottom.
      </p>
      <div className="space-y-0">
        {family.map((f, idx) => (
          <div key={f.id} className="flex gap-3 pb-4 relative">
            <div className="flex flex-col items-center">
              <div className={`h-3 w-3 rounded-full mt-1.5 ${f.is_current ? "bg-[#C5A253] ring-2 ring-[#C5A253]/30" : "bg-[#0B3D3D]"}`} />
              {idx < family.length - 1 && <div className="w-px flex-1 bg-border" />}
            </div>
            <button
              type="button"
              data-testid={`chain-item-${f.id}`}
              onClick={() => !f.is_current && navigate(`/shipments/${f.id}`)}
              disabled={f.is_current}
              className={`flex-1 -mt-0.5 text-left rounded-lg p-2 -ml-1 transition-colors ${
                f.is_current ? "bg-[#FBF3EC] border border-[#F0D8C4]" : "hover:bg-[#F4F6F4] cursor-pointer"
              }`}
            >
              <div className="flex items-center gap-2 flex-wrap">
                <span className="text-xs font-semibold uppercase tracking-wide text-[#8A6D1F]">{f.seq_label}</span>
                {f.is_current && <span className="text-[10px] font-bold text-[#C5A253] uppercase">· viewing</span>}
              </div>
              <div className="flex items-center gap-2 flex-wrap mt-1">
                <span className="text-sm font-medium text-[#111411]">#{f.order_id}</span>
                <StageBadge stage={f.stage} />
                <StatusBadge status={f.status} />
              </div>
              <p className="text-xs text-muted-foreground mt-1">
                AWB {f.tracking_number} · {f.courier_partner}
                {f.is_overdue && <span className="text-[#C24127] font-medium"> · Overdue</span>}
              </p>
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
